// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar___WZixd","default-icon":"default-icon___2LegO"};